import React from "react";
import { useNavigate } from "react-router-dom";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { MessageSquare, Home, TrendingUp, Scale, MapPin, Landmark, FileCheck, Globe } from "lucide-react";

const SERVICES = [
  { icon: MessageSquare, title: "Property Consultation", desc: "One-on-one advisory to understand your needs and recommend the best-fit projects based on budget, location and lifestyle." },
  { icon: Home, title: "Residential Property Sales", desc: "Access to a curated portfolio of apartments, villas and plots across Bangalore's top residential corridors." },
  { icon: TrendingUp, title: "Investment Advisory", desc: "Data-backed guidance on high-growth areas, rental yields and appreciation potential for smart property investments." },
  { icon: Scale, title: "Project & Price Comparison", desc: "Side-by-side comparison of shortlisted projects on price, amenities, builder reputation and possession timelines." },
  { icon: MapPin, title: "Site-Visit Coordination", desc: "We organise and accompany you on structured site visits so you can evaluate projects first-hand." },
  { icon: Landmark, title: "Home-Loan Assistance", desc: "Connections with trusted banks and lenders for competitive home-loan rates and smooth processing." },
  { icon: FileCheck, title: "Documentation & Booking Support", desc: "End-to-end assistance with paperwork, agreements and the complete booking process." },
  { icon: Globe, title: "NRI Property Consultation", desc: "Dedicated remote support for NRIs — virtual tours, documentation and end-to-end coordination." },
];

export default function Services() {
  const navigate = useNavigate();
  return (
    <div>
      <SEO title="Real Estate Services in Bangalore | Property Consultant | Mathura Homes" description="Property consultation, investment advisory, site-visit coordination, home-loan assistance, booking support and NRI consultation in Bangalore." />
      <section className="bg-navy py-20 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <span className="inline-block h-1 w-16 bg-gold mb-6" />
          <h1 className="font-display text-4xl md:text-5xl text-white">Our Services</h1>
          <p className="text-gray-300 mt-5">Comprehensive real estate advisory — from your first enquiry to the keys in your hand.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => (
            <div key={s.title} className="flex gap-5 p-7 rounded-2xl bg-white border border-gray-100 shadow-card hover:shadow-card-hover transition-all" data-testid={`service-${i}`}>
              <span className="shrink-0 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-navy/5 text-navy"><s.icon className="w-7 h-7" strokeWidth={1.5} /></span>
              <div>
                <h3 className="font-display text-xl text-navy mb-2">{s.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-muted py-16 text-center">
        <div className="max-w-2xl mx-auto px-4">
          <h2 className="font-display text-3xl text-navy">Need Help Choosing?</h2>
          <p className="text-muted-foreground mt-3">Talk to our advisors and get a personalised property plan.</p>
          <Button onClick={() => navigate("/contact")} className="mt-6 bg-gold text-navy hover:bg-gold-dark font-semibold px-7 py-6">Book a Free Consultation</Button>
        </div>
      </section>
    </div>
  );
}
